const contactEmail = 'info@sweetestadsmedia.com'
const contactSubject = 'Interactive Business inquiry'
const defaultContactBody = [
  'Hello Sweetest Ads Media team,',
  '',
  'I would like to learn more about Interactive Business software.',
  '',
  '(Enter your name and best contact information)',
].join('\n')

const footerSupportSubject = 'Issues with Interactive Business'
const footerSupportBody = [
  'Hello Sweetest Ads Media team,',
  '',
  'I’m having issues with the Interactive Business software. Can I please receive some assistance?',
  '',
  '(Enter your name and best contact information)',
].join('\n')

const buildMailtoHref = ({ subject, body }) =>
  `mailto:${contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`

const buildContactHref = (body = defaultContactBody) =>
  buildMailtoHref({ subject: contactSubject, body })

const buildFooterSupportHref = () =>
  buildMailtoHref({ subject: footerSupportSubject, body: footerSupportBody })

export {
  buildContactHref,
  buildFooterSupportHref,
  contactEmail,
  contactSubject,
  defaultContactBody,
  footerSupportBody,
  footerSupportSubject,
}
